import { Analytics } from '@cobliteam/analytics';
import { useTranslation } from '@cobliteam/i18n';
import ButtonFilter from '@cobliteam/ui/components/ButtonFilter';
import Icon from '@cobliteam/ui/icons';

export interface MultiSelectVehicleGroupsSidebarTriggerProps {
  totalSelectedGroups: number;
  isOpen: boolean;
}

const MultiSelectVehicleGroupSidebarTrigger = ({ totalSelectedGroups, isOpen }: MultiSelectVehicleGroupsSidebarTriggerProps) => {
  const { t } = useTranslation('multiselects');

  const onDropdownOpen = () => {
    Analytics.track('Global Filter Opened');
  };

  return (
    <ButtonFilter size='sm' icon={<Icon name='filter' />} countBadge={totalSelectedGroups} onClick={onDropdownOpen}>
      {t('groups.filter_groups')}
    </ButtonFilter>
  );
};

export default MultiSelectVehicleGroupSidebarTrigger;
